import { styled, Typography } from '@mui/material';

export const ButtonContainer = styled('div')`
  display: flex;
  align-items: center;
  justify-content: space-between;
  position: relative;
  width: 100%;

  @media (max-width: 1023px) {
    margin-bottom: 16px;
  }
`;

export const TitleW = styled(Typography)(({ theme }) => ({
  fontWeight: 500,
  fontSize: '14px',
  lineHeight: '16px',
  color: theme.palette.info.main,
  marginLeft: '8px',
}));

export const HeaderW = styled('div')`
  display: flex;
  align-items: center;
  gap: 8px;

  & .MuiIconButton-root {
    background-color: ${({ theme }) => theme.palette.info.main};
    width: 24px;
    height: 24px;
    left: 0px;

    &:hover {
      background-color: ${({ theme }) => theme.palette.info.dark};
    }

    & svg {
      color: ${({ theme }) => theme.palette.white.main};
      height: 11px;
    }
  }
`;

export const ActionsW = styled('div')``;
